import { render, staticRenderFns } from "./VsUpload.vue?vue&type=template&id=083fca67&scoped=true"
import script from "./VsUpload.vue?vue&type=script&lang=js"
export * from "./VsUpload.vue?vue&type=script&lang=js"
import style0 from "./VsUpload.vue?vue&type=style&index=0&id=083fca67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fca67",
  null
  
)

export default component.exports